export default __webpack_public_path__ + "static/media/E3.11911220.jpg";